module.exports = __webpack_public_path__ + "img/IMG_1855.ca87df10.jpg";